import { forwardRef } from 'react';
import Proptypes from 'prop-types';
import classnames from 'classnames';

const Avatar = forwardRef((props, ref) => {
  const {
    img,
    icon,
    size,
    color,
    content,
    tag: Tag,
    imgWidth,
    className,
    imgHeight,
    imgClassName,
    ...rest
  } = props;

  // ** Function to extract initials from content
  const getInitials = (str) => {
    const results = [];
    const wordArray = str.split(' ');
    wordArray.forEach((e) => {
      results.push(e[0]);
    });
    return results.join('');
  };

  return (
    <Tag
      className={classnames('avatar', {
        [className]: className,
        [`bg-${color}`]: color,
        [`avatar-${size}`]: size
      })}
      ref={ref}
      {...rest}>
      {img === false || img === undefined ? (
        <span className="avatar-content">
          {content ? getInitials(content) : content}
          {icon ? icon : null}
        </span>
      ) : (
        <img
          className={classnames({
            [imgClassName]: imgClassName
          })}
          src={img}
          alt="avatarImg"
          height={imgHeight && !size ? imgHeight : 32}
          width={imgWidth && !size ? imgWidth : 32}
        />
      )}
    </Tag>
  );
});

Avatar.displayName = 'Avatar';

Avatar.propTypes = {
  icon: Proptypes.node,
  src: Proptypes.string,
  content: Proptypes.string,
  className: Proptypes.string,
  imgClassName: Proptypes.string,
  size: Proptypes.oneOf(['sm', 'lg', 'xl']),
  tag: Proptypes.oneOfType([Proptypes.func, Proptypes.string]),
  imgHeight: Proptypes.oneOfType([Proptypes.string, Proptypes.number]),
  imgWidth: Proptypes.oneOfType([Proptypes.string, Proptypes.number])
};

Avatar.defaultProps = {
  tag: 'div'
};

export default Avatar;
